// extracted by mini-css-extract-plugin
export default {"header":"header__1I7JH","bg-1":"bg-1__TSpfg","bg-2":"bg-2__3aOzj","bg-3":"bg-3__3vYdx","active":"active__36zX-"};